import { render, staticRenderFns } from "./giftcardlogs.vue?vue&type=template&id=7841442c&"
import script from "./giftcardlogs.vue?vue&type=script&lang=js&"
export * from "./giftcardlogs.vue?vue&type=script&lang=js&"
import style0 from "./giftcardlogs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports